import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import _isObjectLike from 'lodash/isObjectLike';
import { createComponent } from '../../services/components';
import { derivePropsFromIterable, areRequiredPropsDefined } from '../../services/props';
import { ComponentPropType } from '../../types/component';
import ClientSideContent from '../ClientSideContent';
var defaultProps = {
  hookParams: [],
  hookToPropsMap: {},
  requiredProps: [],
  onlyRenderOnClientSide: false
};
export default function HookComponentProvider(_ref) {
  var hook = _ref.hook,
    component = _ref.component,
    hookParams = _ref.hookParams,
    hookToPropsMap = _ref.hookToPropsMap,
    requiredProps = _ref.requiredProps,
    onlyRenderOnClientSide = _ref.onlyRenderOnClientSide;
  var hookValues = hook.apply(void 0, _toConsumableArray(hookParams));
  if (!_isObjectLike(hookValues)) {
    hookValues = {
      value: hookValues
    };
  }
  var props = derivePropsFromIterable(hookValues, hookToPropsMap);
  if (!areRequiredPropsDefined(props, requiredProps)) {
    return null;
  }
  var content = createComponent(component, props);
  if (onlyRenderOnClientSide) {
    return /*#__PURE__*/React.createElement(ClientSideContent, null, content);
  }
  return content;
}
HookComponentProvider.defaultProps = defaultProps;